import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PrlInfoRoutingModule} from './prl-info-routing.module';
import {InfoComponent} from './components/info/info.component';

@NgModule({
  declarations: [InfoComponent],
  imports: [
    CommonModule,
    PrlInfoRoutingModule
  ]
})
export class PrlInfoModule {

}
